import { render } from "./App.vue?vue&type=template&id=7518ae30&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=7518ae30&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\99170\\Desktop\\whole-project\\iridea-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7518ae30"]])

export default __exports__